import {PayloadAction, createSlice} from "@reduxjs/toolkit"

export const FooterSlice: any = createSlice({
    name: "footer",
    initialState: {enableFooter: false} as {
        enableFooter: boolean
    },
    reducers: {
        setFooterFunc: (state, {payload: {enableFooter}}: PayloadAction<{enableFooter: boolean}>) => {
            state.enableFooter = enableFooter
        },
    },
})

export const {setFooterFunc} = FooterSlice.actions

export default FooterSlice.reducer
